function injectStyle (ssrContext) {
  require("!!../../../../_extract-text-webpack-plugin@3.0.0@extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../_vue-loader@13.3.0@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-784eca68\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../_vux-loader@1.1.30@vux-loader/src/after-less-loader.js!less-loader?{'modifyVars':{'Success':'#67C23A','Warning':'#E6A23C','Danger':'#ff4400','Info':'#909399','main-text':'#303133','convention-text':'#606266','minor-text':'#909399','placeholder-text':'#C0C4CC','tabbar-text-active-color':'#19be6b','tab-bar-active-color':'#2bc17b','page-bg':'#f1f1f1'},'sourceMap':true}!../../../../_vux-loader@1.1.30@vux-loader/src/style-loader.js!../../../../_vue-loader@13.3.0@vue-loader/lib/selector?type=styles&index=0!./index.vue")
}
var normalizeComponent = require("!../../../../_vue-loader@13.3.0@vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../../../../_vux-loader@1.1.30@vux-loader/src/script-loader.js!../../../../_vue-loader@13.3.0@vue-loader/lib/selector?type=script&index=0!./index.vue"
/* template */
import __vue_template__ from "!!../../../../_vue-loader@13.3.0@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-784eca68\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../_vux-loader@1.1.30@vux-loader/src/before-template-compiler-loader.js!../../../../_vux-loader@1.1.30@vux-loader/src/template-loader.js!../../../../_vue-loader@13.3.0@vue-loader/lib/selector?type=template&index=0!./index.vue"
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vux@2.7.8@vux/src/components/confirm/index.vue
// module id = null
// module chunks = 